<div class="btn-group">
    <button (mouseup)="scrollToSelect(scrollContainer)"
            [ngClass]="color"
            aria-expanded="false"
            class="btn dropdown-toggle"
            data-bs-toggle="dropdown"
            style="font-size: inherit"
            type="button"
    >
        <i *ngIf="icon"
           [class]="icon"
        ></i>
        <span> {{ selected }}</span>
    </button>

    <div class="dropdown-menu" style="padding: 0">
        <input #searchingText
               (input)="search(searchingText.value)"
               class="form-control form-control-sm" data-action="sortPriorityIndexByInput"
               placeholder="{{ 'BUTTON_TEXT.SEARCH' | translate }}"
               style="margin: 5px 0"
               type="text">
        <div (click)="scrollToTop($event, scrollContainer, true)" class="scroll-button">
            <i class="bi bi-caret-up"></i>
        </div>
        <ul #scrollContainer class="table" id="scrollContainer">
            <li *ngFor="let item of range" [class.selected]="item === selected">
				<span (click)="selectItem(item)"
                      class="dropdown-item"
                >
					{{ item }}
				</span>
            </li>
            <li *ngIf="!range.length">
                <i class="dropdown-item">
                    {{ 'EMPTY_FIELDS.NOT_FOUND' | translate }}
                </i>
            </li>
        </ul>
        <div (click)="scrollToTop($event, scrollContainer,false)" class="scroll-button">
            <i class="bi bi-caret-down"></i>
        </div>
    </div>
</div>
